import OrderForLaterWarnSFC from "./OrderForLaterWarn.vue";
export const OrderForLaterWarn = OrderForLaterWarnSFC;
